import { useState } from 'react'

import { PhnxImageHolder } from '@/components/01-atoms/ImageHolder/ImageHolder'

import styles from './ImageCard.module.css'

export interface ImageProps {
  src: string
  alt: string
  animation?: string
  blurPlaceholder?: string
  focus?: string
}

interface ImageCardProps {
  title: string
  paragraph: string
  image: ImageProps
  width?: number | 'full'
}

export const PhnxImageCard = ({
  title,
  paragraph,
  image,
  width = 250,
  ...props
}: ImageCardProps) => {
  const [hover, setHover] = useState(false)
  let setWidth = width as string

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      setHover(!hover)
    }
  }

  const handleClick = () => {
    setHover(!hover)
  }

  // if width is string it will be passed as 100% else it will be px
  if (width === 'full') {
    setWidth = '100%'
  } else {
    setWidth = width - 30 + 'px'
  }

  return (
    <div
      className={styles.container}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      style={{
        height: `${setWidth}`,
        width: `${setWidth}`,
        overflow: 'hidden',
      }}
      role="button"
      aria-pressed={hover}
      aria-label={`Image card for ${title}`}
      aria-labelledby={`image-card-title-${title}`}
      aria-describedby={`image-card-paragraph-${paragraph}`}
      data-testid="image-card"
      {...props}
    >
      <div className={`${styles.image} ${hover ? styles.hover : ''}`}>
        <PhnxImageHolder images={[image]} />
      </div>
      <div
        className={`${styles.background} ${hover ? styles.hover : ''}`}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        role="button"
        aria-label={`Image card for ${title}`}
        aria-pressed={hover}
      ></div>
      {!hover && (
        <div id={`image-card-title-${title}`} className={`${styles.text} ${styles.title}`}>
          {title}
        </div>
      )}
      {hover && (
        <div
          id={`image-card-paragraph-${paragraph}`}
          className={`${styles.text} ${styles.paragraph}`}
        >
          {paragraph}
        </div>
      )}
    </div>
  )
}
